import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './AdminHeader.scss';

const AdminHeader: React.FC = () => {
  const navigate = useNavigate();
  const [adminName, setAdminName] = useState('Admin');

  useEffect(() => {
    const adminUser = localStorage.getItem('adminUser');
    if (adminUser) {
      try {
        const user = JSON.parse(adminUser);
        setAdminName(user.name || user.username || 'Admin');
      } catch (error) {
        console.error('Error parsing admin user:', error);
      }
    }
  }, []);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      navigate('/admin/login');
    }
  };

  return (
    <header className="admin-header">
      <div className="admin-header__container">
        <Link to="/admin" className="admin-header__logo">
          <span className="admin-header__logo-icon">🛡️</span>
          <span className="admin-header__logo-text">Admin Panel</span>
        </Link>
        <nav className="admin-header__nav">
          <Link to="/admin/blogs" className="admin-header__nav-link">Blogs</Link>
          <Link to="/admin/categories" className="admin-header__nav-link">Categories</Link>
          <Link to="/admin/comments" className="admin-header__nav-link">Comments</Link>
          <Link to="/admin/reviews" className="admin-header__nav-link">Reviews</Link>
          <Link to="/admin/portfolio" className="admin-header__nav-link">Portfolio</Link>
          <Link to="/admin/seo" className="admin-header__nav-link">SEO</Link>
          <Link to="/admin/analytics" className="admin-header__nav-link">Analytics</Link>
        </nav>
        <div className="admin-header__user">
          <span className="admin-header__user-name">👤 {adminName}</span>
          <button 
            className="admin-header__logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;

